import { SvgIcon } from '@mui/material';

export default function Roadblock(): JSX.Element {
  return (
    <SvgIcon fontSize="small">
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="951.000000pt"
        height="1080.000000pt"
        viewBox="0 0 951.000000 1080.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
          fill="#000000"
          stroke="none"
        >
          <path
            d="M1385 10791 c-294 -47 -530 -257 -602 -536 -28 -110 -24 -297 9 -397
41 -122 91 -204 187 -299 99 -98 202 -156 328 -187 l73 -17 0 -188 0 -188
-245 3 -244 3 -1 -477 0 -478 451 0 452 0 730 -727 c401 -401 735 -734 742
-741 11 -9 138 -12 567 -12 l553 0 -740 740 -740 740 -417 0 -418 0 0 475 0
475 -245 0 -245 0 2 186 3 186 74 19 c258 65 460 268 527 529 24 90 24 254 0
348 -35 141 -126 283 -243 382 -144 122 -378 190 -558 161z m175 -231 c264
-42 452 -298 410 -559 -17 -108 -57 -190 -130 -265 -196 -204 -507 -209 -705
-11 -195 195 -194 499 2 694 76 75 146 114 244 135 80 18 98 18 179 6z"
          />
          <path
            d="M7908 10785 c-156 -30 -283 -100 -395 -219 -80 -85 -126 -158 -158
-254 -137 -406 95 -836 506 -941 l74 -19 3 -186 2 -186 -245 0 -245 0 0 -475
0 -475 282 0 282 0 136 -133 c524 -514 1350 -1317 1354 -1317 3 0 6 244 6 543
l0 543 -189 182 -189 182 -251 0 -251 0 -2 473 -3 472 -242 3 -243 2 0 188 0
188 63 13 c34 7 105 33 157 58 81 39 107 59 185 137 100 100 146 176 187 306
30 98 33 290 5 390 -99 361 -466 593 -829 525z m227 -230 c96 -21 166 -57 239
-126 204 -190 208 -506 10 -705 -196 -197 -513 -192 -703 12 -71 75 -106 144
-127 248 -44 212 70 438 268 531 111 53 200 64 313 40z"
          />
          <path
            d="M0 7887 l0 -143 599 -597 598 -596 -151 -3 -151 -3 -3 -747 -2 -748
447 0 c247 0 453 -4 460 -8 6 -4 342 -337 747 -740 l735 -732 553 0 553 0
-740 740 -740 740 -417 0 -418 0 0 750 0 750 117 0 118 0 -740 740 -740 740
-412 0 -413 0 0 -143z"
          />
          <path
            d="M3880 8026 c0 -3 332 -335 738 -740 l737 -735 555 -1 555 0 -740 740
-740 740 -552 0 c-304 0 -553 -2 -553 -4z"
          />
          <path
            d="M5960 8022 c0 -5 73 -80 163 -166 89 -87 424 -420 745 -740 l582
-581 0 -742 0 -743 282 0 282 0 110 -108 c61 -59 282 -274 491 -477 209 -203
472 -460 585 -571 113 -110 229 -222 258 -249 l52 -48 0 545 0 546 -189 181
-189 181 -251 0 -251 0 -2 748 -3 747 -41 3 c-39 3 -64 27 -779 742 l-740 740
-552 0 c-304 0 -553 -4 -553 -8z"
          />
          <path
            d="M0 4906 l0 -144 601 -596 602 -596 -157 0 -156 0 0 -1155 0 -1155
-225 0 -225 0 0 -230 c0 -198 -2 -230 -15 -230 -31 0 -10 -28 42 -57 13 -7 45
-13 72 -13 28 0 53 -4 56 -10 4 -6 187 -10 515 -10 328 0 511 -4 515 -10 8
-14 268 -13 281 0 7 7 108 11 290 11 l280 -1 37 31 c35 29 49 59 27 59 -6 0
-10 83 -10 230 l0 230 -230 0 -230 0 0 1155 0 1155 117 0 118 0 -740 740 -740
740 -412 0 -413 0 0 -144z"
          />
          <path
            d="M3880 5047 c0 -5 1362 -1364 1427 -1424 l57 -53 551 0 550 0 -740
740 -740 740 -552 0 c-304 0 -553 -1 -553 -3z"
          />
          <path
            d="M5960 5045 c0 -7 1470 -1469 1481 -1473 5 -2 9 -471 9 -1158 l0
-1154 -224 0 -223 0 -7 -31 c-3 -17 -6 -121 -6 -230 0 -165 -2 -199 -14 -199
-12 0 -12 -5 1 -31 8 -17 23 -33 32 -36 9 -2 25 -9 36 -14 11 -5 265 -11 565
-13 300 -2 565 -7 588 -11 28 -5 48 -3 55 4 8 8 127 11 397 11 l385 0 38 31
c35 29 49 59 27 59 -6 0 -11 87 -12 228 l-3 227 -227 3 -228 2 0 1155 0 1155
-43 0 -42 0 -740 740 -740 740 -552 0 c-304 0 -553 -2 -553 -5z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
